import { IconColors, MagnifyingGlass } from 'Icons';
import React from 'react';
import { FlexWrapper } from 'Shared/FlexWrapper';

import { Search } from './Search';
import styles from './search-bar.module.css';

interface SearchBarProps {
    /** Fired as the term is typed (debounced by `Search`), on Enter, on clear, and on submit. */
    onSearch: (searchTerm: string) => void;
    placeholder: string;
    /** Accessible label for the submit button. Falls back to the placeholder. */
    submitLabel?: string;
    initialValue?: string;
    className?: string;
}

/**
 * The search input paired with a magnifying-glass submit button, as used above the admin list tables.
 */
const SearchBar: React.FC<SearchBarProps> = ({ onSearch, placeholder, submitLabel, initialValue = '', className = '' }) => {
    const [searchTerm, setSearchTerm] = React.useState<string>(initialValue);

    const handleTermChange = (term: string) => {
        setSearchTerm(term);
        onSearch(term);
    };

    const clear = () => {
        setSearchTerm('');
        onSearch('');
    };

    return (
        <FlexWrapper justify="between" align="center" gap="0.5rem" fullWidth className={`${styles.SearchBar} ${className}`}>
            <Search
                handler={handleTermChange}
                keyboardHandler={handleTermChange}
                clearCallback={clear}
                placeholder={placeholder}
                initialValue={initialValue}
                aria-label={placeholder}
            />
            <button
                type="button"
                onClick={() => onSearch(searchTerm)}
                className={styles.SubmitButton}
                aria-label={submitLabel || placeholder}
            >
                <MagnifyingGlass aspect="1.5rem" color={IconColors.Action} />
            </button>
        </FlexWrapper>
    );
};

export default SearchBar;
